import React, { useEffect } from "react";
import { Card, Typography, List } from "antd";
import ApplicationClientCard from "./components/ApplicationClientCard";
import "./index.css";

import { leaderBoard } from "../ducks/service";
import { useQuery } from "@tanstack/react-query";
import LoaderTsx from "../../../Loader.tsx";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";

const { Title } = Typography;

const ApplicationStatics: React.FC = React.memo(() => {
  const filterData = useDashboardFilterContext();

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["leaderBoard", filterData?.queryParams],
    queryFn: () => leaderBoard(filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });
  
  const applicationData = data?.result ? [...data?.result] : [];

  return (
    <Card
      style={{
        margin: "24px 16px",
        border: "none",
        borderRadius: 8,
      }}
    >
      <Title level={4} style={{ marginBottom: 16 }}>
        <span
          style={{
            fontWeight: 700,
            color: "#1F5782",
            textTransform: "uppercase",
          }}
        >
          Leader
        </span>{" "}
        <span
          style={{
            fontWeight: 400,
            color: "#1F5782",
            textTransform: "uppercase",
          }}
        >
          Board
        </span>
      </Title>

      {isLoading ? (
        <LoaderTsx />
      ) : (
        <List
          header={
            <div className="application-list-header">
              <span style={{ flex: "2 1 250px", color: "#333" }}>Lease Executive</span>
              <span style={{ flex: "1 1 120px", textAlign: "center", color: "#333" }}>Rank</span>
              <span style={{ flex: "1 1 100px", textAlign: "center", color: "#333" }}>Created Bookings</span>
              <span style={{ flex: "1 1 120px", textAlign: "center", color: "#333" }}>Completed Bookings</span>
              <span style={{ flex: "1 1 100px", textAlign: "center", color: "#333" }}>Achievement</span>
            </div>
          }
          dataSource={applicationData}
          renderItem={(item, index) => (
            <ApplicationClientCard
              index={index}
              name={item?.managerName}
              position={index + 1}
              createdBookings={item.createdCount}
              createdBookingValues={item.createdAmount}
              completedBookings={item.completedCount}
              completedBookingValues={item.completedAmount}
              achievement={item?.achievement}
            />
          )}
          itemLayout="horizontal"
        />
      )}
    </Card>
  );
});

export default React.memo(ApplicationStatics);
